import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import SSOUser from "../SSOUser";
import PathogenicityPill from "../../atoms/PathogenicityPill";
import HorizontalStackedBar from "../../atoms/HorizontalStackedBar";
import HoverTooltip from "../../atoms/Tooltip/HoverTooltip";
import sortScores from "./sortScores";
import { getPathogenicitiesPerArticle } from "../../../state/selectors/PubmedUserEntries.selectors";

const calculateText = (pathogenicity, total, isLarge) => {
  const percentage = pathogenicity.times / total;

  if (percentage > 0.8 && isLarge) {
    return `${pathogenicity.name} (${pathogenicity.times})`;
  }
  if (percentage > 0.4) {
    return `${pathogenicity.pathogenicity} (${pathogenicity.times})`;
  }

  return `${pathogenicity.times}`;
};

function PathogenicityBarchart({ containerRenderer, isLarge, entries }) {
  const total = entries.reduce((a, i) => a + i.times, 0);
  const maxUsers = 3;
  const pathogenicityBarChart = (entries || [])
    .map((x, i) => ({
      ...x,
      value: x.times,
      color: x.color,
      key: `${i}-${new Date().getTime()}`,
      text: calculateText(x, total, isLarge),
      score: sortScores[x.pathogenicity],
    }))
    .sort((a, b) => b.score - a.score);

  const chart = (
    <HorizontalStackedBar
      containerClassName={`${
        isLarge ? "tw-h-8 tw-rounded-full" : "tw-h-5 tw-rounded-lg tw-min-w-24"
      }  tw-text-white tw-font-semibold tw-text-3xs`}
      data={pathogenicityBarChart}
    />
  );

  const content = containerRenderer ? containerRenderer(total, chart) : chart;
  return entries && entries.length ? (
    <HoverTooltip
      ContentRenderer={() => (
        <div className="">
          {pathogenicityBarChart.map((e) => {
            return (
              <div key={e.key} className="tw-p-4">
                <div className="tw-flex tw-gap-x-2 tw-items-center">
                  {e.users.slice(0, maxUsers).map((x) => {
                    return (
                      <div key={x.ssoId} className="tw-flex-shrink-0">
                        <SSOUser ssoId={x.ssoId} isCoAuthor={x.coAuthor} />
                      </div>
                    );
                  })}
                  <div className="tw-flex-shrink-0">
                    {e.users.length > maxUsers
                      ? `+ ${e.users.length - maxUsers} more`
                      : ""}
                  </div>
                </div>
                <div className="tw-flex tw-flex-wrap tw-gap-x-2">
                  <span className="tw-pr-2">classified as</span>
                  <div className="tw-text-2xs tw-font-bold tw-inline-block">
                    <PathogenicityPill pathogenicity={e.pathogenicity} />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    >
      <div className="tw-cursor-pointer">{content}</div>
    </HoverTooltip>
  ) : null;
}

PathogenicityBarchart.propTypes = {
  isLarge: PropTypes.bool,
  entries: PropTypes.arrayOf(PropTypes.shape({})),
  containerRenderer: PropTypes.func,
};

PathogenicityBarchart.defaultProps = {
  isLarge: false,
  entries: [],
  containerRenderer: null,
};

const mapStateToProps = (state, props) => {
  const { pubmedId } = props;
  const allEntries = getPathogenicitiesPerArticle(state);
  const entries = allEntries[`${pubmedId}`] || [];
  return { entries };
};

export default connect(mapStateToProps, {})(React.memo(PathogenicityBarchart));
